export default [
    {
        path: "consultorias/catalogo-consultoras",
        name: "catalogo-consultoras",
        component: () =>
            import(/* webpackChunkName: "catalogoConsultoras" */ "../consultora/views/catalogoConsultoras.vue"),
    },
]